export const rss = () => (
  <path
    fill="inherit"
    fillRule="evenodd"
    d="M5.88 15.24a2.88 2.88 0 1 1 0 5.76 2.88 2.88 0 0 1 0-5.76M3 3c9.941 0 18 8.059 18 18h-2.88c0-8.35-6.77-15.12-15.12-15.12zm0 5.4c6.959 0 12.6 5.641 12.6 12.6h-2.88c0-5.368-4.352-9.72-9.72-9.72z"
    clipRule="evenodd"
  />
);
